// Older events have no reliable indication of which screen made the change.
export function isVisibleAuditEntry(entry) {
  return entry.source === "PopupShift" && ["Pass", "Bokning", "Övertidsregel", "Frånvarotyp"].includes(entry.category);
}
